export default {
    //Splash
    splash_message: 'Platform komunikasi dan pembelajaran',

    //TTCC
    accept_ttcc: 'Terima syarat dan ketentuan penggunaan',

    //Login
    welcome: 'Selamat datang!',
    welcome_message: 'dots, mitra teknologi baru Anda untuk komunikasi dan pembelajaran.',
    username: 'Nama pengguna',
    password: 'Kata sandi',
    code: 'Kode',
    recover_password: 'Pulihkan kata sandi',
    log_in: 'Masuk',
    log_in_biometrics: 'Masuk dengan data biometrik',
    create_user: 'Buat pengguna',
    recover_access_to_account: 'Masukkan nama pengguna Anda untuk memulihkan akses ke akun Anda',
    back: 'Kembali',
    enter_new_password: 'Masukkan kode dan kata sandi baru Anda',
    enter_code: 'Masukkan kode',
    new_password: 'Kata sandi baru',
    repeat_new_password: 'Ulangi kata sandi baru',
    validate: 'Validasi',
    complete_all_fields: 'Lengkapi semua kolom',
    passwords_do_not_match: 'Kata sandi tidak cocok',
    user_created_successfully: 'Pengguna berhasil dibuat',
    create_user: 'Buat pengguna',
    required_fields: 'Kolom wajib',
    confirm_your_email: 'Konfirmasi email Anda',
    confirm_your_phone: 'Konfirmasi telepon Anda',
    confirm_password: 'Konfirmasi kata sandi',
    modifying_email: 'Anda sedang mengubah email Anda',
    validate_code: 'Validasi kode',
    code_sent_successfully: 'Kode berhasil dikirim',
    password_reset: 'Kata sandi Anda berhasil direset',
    enter_confirmation_code: 'Masukkan kode konfirmasi',
    enter_your_new_email: 'Masukkan email baru Anda',
    //nuevos al 01-08-2024
    user_does_not_exist: 'Ups! Kami tidak dapat menemukan akun Anda',
    contact_the_administrator: 'Sepertinya pengguna yang Anda masukkan tidak ada.\nPastikan itu ditulis dengan benar\ndan hubungi administrator.',
    invalid_user_or_pass: 'Nama pengguna dan/atau kata sandi tidak valid',
    info_is_not_correct: 'Beberapa informasi tidak benar, silakan coba lagi.',
    enter_user: 'Silakan masukkan nama pengguna',
    nonexistent_user: 'Pengguna tidak ada. Silakan coba lagi.',
    incorrect_code: 'Kode salah',
    change_saved_successfully: 'Perubahan berhasil disimpan',
    pass_changed_successfully: 'Kata sandi berhasil diubah',
    check_your_email: 'Periksa email Anda untuk memasukkan kode validasi',
    eight_characters: '*Harus berisi lebih dari 8 karakter',
    one_uppercase_letter: '*Harus berisi setidaknya 1 huruf besar',
    one_special_character: '*Harus berisi setidaknya 1 karakter khusus (@,$,!,#,?)',
    pass_requirements:
        'Anda harus memenuhi persyaratan berikut:\n\n*Harus berisi lebih dari 8 karakter\n*Harus berisi setidaknya 1 huruf besar\n*Harus berisi setidaknya 1 karakter khusus (misalnya: $, !, #, ?)',
    select_date: 'Pilih tanggal',
    cannot_create_password: 'Tidak dapat membuat kata sandi',
    complete_your_details: 'Lengkapi detail Anda untuk melanjutkan',
    validate_code: 'Validasi kode',
    enter_valid_number: 'Anda harus memasukkan nomor yang valid',
    complete_numbers:
        'Awalan "15" harus dihapus sehingga nomor akhirnya memiliki total 13 digit, contohnya: +54 9 XXX XXX XXXX, Anda harus melengkapi 10 digit yang tersisa.',

    //Profile
    insufficient_permissions: 'Izin tidak mencukupi',
    permissions_are_required: 'Izin diperlukan untuk mengakses kamera dan galeri foto.',
    choose_font: 'Pilih sumber',
    where_do_you_want: 'Dari mana Anda ingin memilih gambar?',
    camera: 'Kamera',
    gallery: 'Galeri',
    edit_photo: 'Edit foto',
    cancel: 'Batal',
    save: 'Simpan',
    app: 'Aplikasi',
    support: 'Dukungan',
    other: 'Lainnya',
    contact_channel: 'Saluran kontak',
    select_the_contact_channel: 'Pilih saluran kontak',
    subject: 'Subjek',
    write_the_subject: 'Tulis subjek',
    message: 'Pesan',
    write_a_comment: 'Tulis komentar',
    send: 'Kirim',
    sent_successfully: 'Berhasil dikirim',
    thank_you_for_leaving_us_your_comments: 'Terima kasih telah meninggalkan komentar Anda, kami akan menghubungi Anda segera.',
    close: 'Tutup',
    check_for_update: 'Periksa pembaruan',
    clear_cache: 'Bersihkan cache',
    delete_account: 'Hapus akun',
    log_out: 'Keluar',
    notifications: 'Notifikasi',
    insufficient_permissions: 'Izin tidak mencukupi',
    permissions_to_access: 'Izin diperlukan untuk mengakses kamera dan galeri foto.',
    choose_font: 'Pilih sumber',
    select_the_image: 'Dari mana Anda ingin memilih gambar?',
    change_language: 'Ganti BAHASA',
    change_language_title: 'Penting!',
    change_language_message:
        'Untuk melakukan tindakan ini, diperlukan koneksi internet. Ini akan menghapus konten yang diunduh untuk penggunaan offline. Harap diperhatikan bahwa perubahan hanya akan memengaruhi konten aplikasi dan bukan struktur aplikasi, yang bergantung pada bahasa perangkat Anda.',
    logout_not_available: 'Logout tidak tersedia',
    cant_logout: 'Anda tidak dapat logout saat ini karena tidak ada koneksi internet. Silakan periksa koneksi Anda dan coba lagi.',
    //nuevos al 01-08-2024
    cache_cleared: 'Cache berhasil dibersihkan',
    deletes_the_content:
        'Tindakan ini menghapus konten yang diunduh untuk penggunaan aplikasi dalam mode offline. Pastikan Anda terhubung untuk melanjutkan penelusuran.',
    error_uploading_image: 'Kesalahan saat mengunggah gambar: ',
    there_was_an_error: 'Terjadi kesalahan saat mengunggah gambar. Silakan coba lagi.',
    //nuevos al 21-11-2024
    email: 'Email',
    phone: 'Telepon',
    name: 'Nama',
    last_name: 'Nama belakang',
    role: 'Peran',
    verify: 'Verifikasi',
    verified: 'Terverifikasi',
    contact_channels: 'Saluran kontak',
    editing_your_email: 'Anda sedang mengedit email Anda',
    editing_your_phone: 'Anda sedang mengedit nomor telepon Anda',
    modifying_your_email:
        'Anda sedang memodifikasi email Anda, Anda akan menerima kode di email Anda untuk dimasukkan. Jika Anda belum menerima kode tersebut, silakan periksa lagi.',
    modifying_your_phone:
        'Anda sedang memodifikasi nomor ponsel Anda, Anda akan menerima kode SMS untuk dimasukkan. Jika Anda belum menerima kode tersebut, silakan periksa lagi.',

    //Notifications
    all: 'Semua',
    unread: 'Belum dibaca',
    read: 'Dibaca',
    seen: 'Dilihat',
    notifications: 'Notifikasi',
    here_you_will_find: 'Di sini Anda akan menemukan semua peringatan dan pemberitahuan!',
    mark_all_read: 'Tandai semua sebagai dibaca',
    you_have_no_notifications: 'Anda tidak memiliki pemberitahuan!',
    you_will_soon_start: 'Anda akan segera menerima pemberitahuan baru',

    //Buscador
    enter_your_search: 'Masukkan pencarian Anda',
    no_results: 'Tidak ada hasil',
    search_content: 'Cari konten yang Anda minati.',
    see: 'Lihat',
    results_in: 'hasil dalam',
    see_less_results: 'Lihat lebih sedikit hasil',
    all: 'Semua',
    wall: 'Dinding',
    learning: 'Pembelajaran',
    benefits: 'Manfaat',
    portfolio: 'Portofolio',
    retry: 'Coba lagi',
    locked: 'Terkunci',
    pending: 'Tertunda',
    seen: 'Dilihat',
    approved: 'Disetujui',

    //Posts
    see_them: 'Lihat semuanya',
    _comments: ' komentar',
    reactions_from_other_users: 'Reaksi dari pengguna lain',
    not_connected_to_the_network: 'Tidak terhubung ke jaringan',
    comment: 'Komentar',
    comments: 'Komentar',
    write_a_comment: 'Tulis komentar',
    no_content: 'Tidak ada konten',
    reaction: 'Reaksi',
    reactions: 'Reaksi',
    first_comment: 'Jadilah yang pertama berkomentar!',
    no_comment: 'Belum ada komentar pada kiriman ini.',
    write_a_comment: 'Tulis komentar',
    no_publications: 'Tidak ada publikasi',
    no_post_to_read: 'Anda tidak memiliki kiriman untuk dibaca.',
    views: 'tampilan',
    reply: 'Balas',
    see: 'Lihat',
    more_answers: 'jawaban lebih',
    hide: 'Sembunyikan',
    answers: ' jawaban',
    no_reactions: 'Belum ada reaksi!',
    leave_your_reaction: 'Jadilah yang pertama meninggalkan reaksi.',
    //nuevos al 01-08-2024
    full_survey: 'Anda telah menyelesaikan survei!',
    thanks_for_participating: 'Terima kasih telah berpartisipasi! Pantau terus dinding untuk pembaruan lebih lanjut.',
    sent_automatically: 'Akan dikirim secara otomatis ketika Anda kembali terhubung.',
    no_post_saved: 'Belum ada postingan yang disimpan',
    see_your_favorite_content: 'Di sini Anda akan melihat konten favorit Anda.',

    //fechas
    instant: 'Baru saja',
    hourFirst: 'Yang lalu',
    hour: ' jam',
    hours: ' jam',
    day: ' hari',
    days: ' hari',

    //Learning
    congratulations: 'Selamat!',
    you_approved: 'Anda telah lulus',
    you_completed: 'Anda telah menyelesaikan kursus ini',
    you_disapproved: 'Penilaian tidak berhasil',
    score: 'Nilai:',
    return_to_course: 'Kembali ke kursus',
    retry: 'Coba lagi',
    it_is_available: 'Sekarang tersedia',
    total_course_evaluation: 'Evaluasi total kursus',
    evaluate_me: 'EVALUASI SAYA',
    completed_the_course: 'Anda telah menyelesaikan kursus',
    pending_approval: 'Menunggu persetujuan',
    return: 'Kembali',
    continue_course: 'Lanjutkan kursus',
    you_have_made: 'Anda telah menyelesaikan',
    of_the_course: ' kursus',
    locked: 'terkunci',
    pending: 'tertunda',
    seen: 'dilihat',
    complete: 'selesai',
    reprobate: 'gagal',
    sync_pend: 'menunggu sinkronisasi',
    in_progress: 'sedang berlangsung',
    perform_evaluation: 'Lakukan evaluasi',
    next_content: 'Konten berikutnya',
    you_completed_all: 'Anda telah menyelesaikan semua konten',
    final_evaluation: 'EVALUASI AKHIR',
    retry_mayus: 'COBA LAGI',
    see_more: '...lebih banyak',
    see_less: '...lebih sedikit',
    back_to_course: 'KEMBALI KE KURSUS',
    click_to_see: 'Klik untuk melihat',
    //Evaluaciones
    evaluation: 'Evaluasi: ',
    of: ' dari ',
    loading_evaluation: 'Memuat evaluasi...',
    select_option: 'Anda harus memilih opsi untuk melanjutkan',
    select_one_answer: 'Pilih setidaknya satu jawaban untuk setiap pertanyaan.',
    exit_evaluation: 'Apakah Anda ingin keluar dari evaluasi?',
    your_answers_will_not_be_saved: 'Jika Anda keluar sekarang, jawaban Anda tidak akan disimpan',
    continue_evaluation: 'Lanjutkan evaluasi',
    leave_anyway: 'Keluar bagaimanapun juga',
    try_again: 'Coba lagi!',
    passed_the_evaluation: 'Anda telah lulus evaluasi',
    start_the_course_again: 'Anda belum menyelesaikan evaluasi. Mulai ulang kursus.',
    evaluation_pending_approval: 'Evaluasi tertunda',
    notification_result_evaluation: 'Anda akan diberitahu tentang hasil evaluasi Anda segera',
    write_here: 'Tulis di sini...',
    close: 'Tutup',
    confirm: 'Konfirmasi',
    sync_pending: 'Menunggu sinkronisasi',
    view_certificate: 'Lihat sertifikat',
    search_store: 'Cari toko...',
    no_results_for_your_search: 'Tidak ada hasil untuk pencarian Anda',
    find_another_store: 'Cari toko lain',
    // nuevos al 27-01-2025
    course_download_in_process: 'Pengunduhan kursus sedang berlangsung',
    course_is_downloading:
        'Silakan tunggu beberapa detik. Kursus sedang diunduh agar Anda dapat mengakses semua konten secara offline tanpa masalah.',
    downloaded_course: 'Kursus berhasil diunduh',
    you_can_train_offline: 'Selesai! Sekarang Anda bisa berlatih secara offline.',
    delete_offline_course: 'Apakah Anda ingin menghapus unduhan kursus offline ini?',
    not_view_course_offline: 'Anda tidak akan bisa melihat kursus ini secara offline.',
    course_is_not_available: 'Kursus tidak tersedia lagi...',
    not_available_offline: 'Kursus ini sudah tidak tersedia secara offline, tapi Anda dapat mengunduhnya lagi kapan saja jika diperlukan.',
    content_download_in_process: 'Pengunduhan konten sedang berlangsung',
    content_is_downloading: 'Silakan tunggu beberapa detik. Konten sedang diunduh agar Anda dapat mengaksesnya secara offline tanpa masalah.',
    downloaded_content: 'Konten berhasil diunduh',
    delete_offline_content: 'Apakah Anda ingin menghapus konten offline?',
    not_view_content_offline: 'Dengan menghapusnya, Anda tidak akan bisa mengakses konten secara offline.',
    content_is_not_available: 'Konten tidak tersedia lagi...',
    download_offline: 'Unduh secara offline',
    available_offline: 'Tersedia offline',
    delete: 'Menghapus',

    //Stores
    your_progress_in_stores: 'Kemajuan Anda di toko',
    map: 'Peta',
    daily_survey: 'Survei harian',
    survey: 'Survei',
    matutino: 'Pagi',
    vespertino: 'Sore',
    form: 'Formulir',
    enter_a_number: 'Masukkan nomor',
    campaign_expiration: 'KAMPANYE KADALUARSA: ',
    store_indicators: 'Indikator toko',
    last_days: '30 hari terakhir',
    main_indicators: 'Ketahui indikator utama toko Anda',
    store_information: 'Temukan informasi lengkap tentang toko Anda',
    perform_executions: 'Lakukan tugas berikut untuk mengetahui status toko Anda',
    pending_mayus: 'MENUNGGU',
    approved_mayus: 'DISETUJUI',
    in_review_mayus: 'DALAM ULASAN',
    redo_mayus: 'ULANGI',
    visited_mayus: 'DIKUNJUNGI',
    moderation_mayus: 'MODERASI',
    review_mayus: 'ULASAN',
    in_progress_mayus: 'SEDANG BERLANGSUNG',
    sync_pend_mayus: 'MENUNGGU SINKRONISASI',
    locked_mayus: 'TERKUNCI',
    complete_mayus: 'MENYELESAIKAN',
    perfect_store: 'Toko sempurna',
    execution: 'Eksekusi',
    vouchers: 'Voucher',
    send: 'Kirim',
    requires: 'Membutuhkan ',
    variation: 'Variasi',
    validity: 'Masa berlaku: ',
    points: 'poin',
    voucher_canceled: 'Voucher dibatalkan',
    you_can_try_again: 'Jangan khawatir! Coba lagi.',
    voucher_successful: 'Voucher berhasil dilakukan',
    successful_promo: 'Promo berhasil!',
    voucher_pending: 'Voucher tertunda',
    wait_for_the_validation: 'Tunggu validasi voucher',
    your_code_is_being_scanned: 'Kode Anda sedang dipindai ⏳',
    view_qr: 'Lihat QR',
    return_to_store: 'Kembali ke toko',
    stores_objective: 'Anda perlu memenuhi tujuan toko.',
    welcome_stores: 'Selamat datang di toko!',
    tip_day: 'Di sini Anda dapat melihat toko harian Anda, mengisi survei yang diperlukan, dan melacak kemajuan Anda.',
    close_mayus: 'TUTUP',
    select_form: 'Pilih formulir untuk memulai',
    select_one_form: 'Anda harus memilih satu formulir untuk memulai survei.',
    answer_all_questions: 'Anda harus menjawab semua pertanyaan untuk melanjutkan.',
    schedule_not_found: 'Jadwal tidak ditemukan untuk hari ini.',
    form_not_found: 'Formulir tidak ditemukan dalam jadwal.',
    send: 'Kirim',
    check_in: 'Check-in',
    check_out: 'Check-out',
    check_out_done: 'Check-out berhasil',
    off_route: 'Anda keluar dari rute, klik di sini untuk kembali ke jadwal',
    search_barcode: 'Cari dengan kode batang',
    no_agenda_today: 'Anda tidak memiliki jadwal hari ini!',
    no_agenda_week: 'Anda tidak memiliki jadwal minggu ini!',
    no_information_today: 'Anda tidak memiliki jadwal untuk hari ini, hubungi atasan Anda jika ada pertanyaan.',
    no_information_week: 'Tidak ada informasi yang diambil untuk pengguna, hubungi atasan Anda jika ada pertanyaan.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'Anda tidak memiliki izin kamera',
    activate_from_settings: 'Aktifkan dari pengaturan perangkat Anda untuk melanjutkan.',
    modify_permissions: 'Ubah izin',
    complete_fields: 'Lengkapi kolom berikut untuk membuat toko',
    create: 'Buat',
    store_name: 'Nama Toko',
    enter_store_name: 'Masukkan nama toko',
    sore_address: 'Alamat',
    enter_sore_address: 'Masukkan alamat toko',
    cluster: 'Kluster',
    store_phone: 'Telepon',
    enter_sore_phone: 'Masukkan telepon toko',
    activate_survey: 'Untuk mengaktifkan survei 1.1 Vespertino, Anda harus menyelesaikan tujuan toko. Tujuan: ',
    inactive_vespertino: 'Vespertino tidak aktif',
    active_vespertino: 'Vespertino aktif',
    completed_your_mandatory_objectives: 'Anda telah menyelesaikan tujuan wajib hari ini, Anda sekarang dapat melakukan Vespertino Anda.',
    complete_now: 'Selesaikan sekarang',
    perform_later: 'Lakukan nanti',
    back_to_your_agenda: 'Apakah Anda ingin kembali ke agenda hari ini?',
    return_to_the_current_day: 'Anda sedang melihat aktivitas dari hari-hari sebelumnya, jika Anda mengetuk terus, Anda akan kembali ke hari ini: ',
    continue: 'Lanjutkan',
    reached_your_goal: 'Anda telah mencapai tujuan Anda!',
    search_by_barcode: 'Cari berdasarkan kode batang',
    scan_the_barcode: 'Pindai kode batang dari produk apa pun\ndalam daftar survei ini.',
    return_to_form: 'Kembali ke Formulir',
    product_not_found: 'Produk tidak ditemukan',
    code_does_not_match: 'Kode tidak cocok dengan produk yang terkait dengan formulir ini.',
    search_another_product: 'Cari produk lain',
    form_submitted_successfully: ' telah berhasil!',
    send_new_survey: 'Jika Anda mau, Anda dapat mengirimkan survei baru.',
    no_agenda_for_today: 'Tidak ada agenda untuk hari ini!',
    consult_your_supervisor: 'Anda tidak memiliki agenda untuk tanggal ini, jika ada pertanyaan, silakan konsultasikan dengan supervisor Anda.',
    visiting_your_store: 'Anda sedang mengunjungi toko Anda ',
    you_can_check_out: 'Anda dapat melakukan Check-out tanpa menyelesaikan survei: ',
    you_met_the_goal: 'Anda telah mencapai tujuan, tidak perlu menyelesaikan formulir.',
    you_must_complete_the_survey: 'Untuk melakukan Check-out, Anda harus menyelesaikan survei: ',
    checkin_blocked: 'Check-in diblokir',
    close_the_open_checkin: 'Untuk melanjutkan, Anda harus menutup Check-in yang terbuka.',
    close_the_checkin_opened_in: 'Untuk melanjutkan, Anda harus menutup Check-in yang terbuka di: ',
    checkin_out_of_range: 'Check-in di luar jangkauan',
    more_meters_from_the_store: 'Anda berada lebih dari 150 meter dari toko.',
    now_is_your_turn: 'Sekarang giliran Anda!',
    surveys_in_progress: 'Anda memiliki survei yang sedang berlangsung: ',
    unfinished_surveys: 'Anda memiliki survei yang belum selesai: ',
    want_to_checkout: 'Apakah Anda yakin ingin melakukan Check-out?',
    selected_store: 'Toko yang dipilih',
    checkout_blocked: 'Check-out diblokir',
    uncompleted_forms: 'Anda memiliki formulir yang belum selesai!',
    checkout_anyway: 'Apakah Anda ingin melakukan Check-out bagaimanapun?',
    go_to_survey: 'Pergi ke survei',
    take_the_survey: 'Sekarang Anda dapat menyelesaikan survei!',
    validity: 'Berlaku: ',
    //nuevos al 21-11-2024
    loading: 'Memuat...',
    error_getting_data: 'Kesalahan saat mendapatkan data.',
    no_information_to_display: 'Tidak ada informasi untuk ditampilkan.',
    unzipping: 'Membuka zip...',
    saving: 'Menyimpan',
    loading_stores: 'Memuat toko...',
    getting_stores: 'Mengambil toko...',
    request_has_failed: 'Jumlah percobaan maksimum tercapai. Permintaan gagal.',
    a_few_minutes: 'Memuat toko...\nProses ini mungkin memakan waktu beberapa menit.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Unduhan aset Perfect Store selesai',
    perfect_store_download: 'Unduhan foto sukses Perfect Store selesai',
    perfect_store_error: 'Terjadi kesalahan saat mengunduh aset Perfect Store',
    connection_interrupted: 'Koneksi terputus, foto sukses akan didekompresi setelah koneksi dipulihkan',
    decompressing_perfect_store: 'Mengunduh Toko Sempurna',
    downloading_perfect_store: 'Mengunduh Toko Sempurna',
    saving_perfect_store: 'Menyimpan Toko Sempurna',
    remain_downloaded: '\nSisa yang perlu diunduh ',
    assets: ' aset.',
    download_complete: 'Unduhan selesai',

    //Portfolio
    no_brands_to_show: 'Tidak ada merek yang ditampilkan',
    no_products_to_show: 'Tidak ada produk yang ditampilkan',
    try_again_later: 'Coba lagi nanti',
    portfolio: 'Portofolio',
    select_one: 'Pilih salah satu merek kami untuk melihat produk dan layanan.',
    learn_about: 'Pelajari tentang semua produk dan layanan di aplikasi kami.',
    //nuevos al 01-08-2024
    brand: 'Merek',
    description: 'Deskripsi',
    ingredients: 'Bahan-bahan',
    data_sheet: 'Lembar data',

    //Benefits
    points_can_be_exchanged: 'Poin dapat ditukar dengan:',
    approved: 'Disetujui',
    cancelled: 'Dibatalkan',
    pending: 'Tertunda',
    redeemed: 'DITUKARKAN',
    added_points: 'POIN DITAMBAHKAN',
    all: 'Semua',
    my_points: 'Poin saya',
    your_points: 'Poin Anda',
    delivered: 'Dikirim',
    no_benefits: 'Belum ada manfaat',
    add_points: 'Dapatkan poin dengan berinteraksi dan tukarkan',
    no_history: 'Belum ada riwayat',
    redeem_your_points: 'Tukarkan poin Anda dan lihat riwayat manfaat di sini',
    pending_approval: 'Menunggu persetujuan',
    when_it_is_approved: 'Setelah disetujui, itu akan muncul dalam riwayat manfaat',
    unredeemed_benefit: 'Manfaat yang belum ditukarkan',
    you_dont_have_enough_points: 'Anda tidak memiliki cukup poin untuk menukarkan manfaat ini',
    accept: 'Terima',
    units_available: ' unit tersedia',
    redeem_benefit: 'Tukarkan manfaat',
    benefits_mayus: 'MANFAAT',
    history: 'RIWAYAT',
    there_was_a_mistake: 'Terjadi kesalahan',

    //Vouchers
    complete_to_redeem_the_voucher: 'Lengkapi untuk menukarkan voucher',
    valid_until: 'Masa berlaku: ',
    quantity_purchased: 'Jumlah dibeli: ',
    redeem: 'Tukarkan',
    lumps: 'Gumpalan',
    voucher_redeemed: 'Voucher berhasil ditukarkan',
    error_redeeming_voucher: 'Terjadi kesalahan saat menukarkan voucher. Coba lagi.',
    validate_and_redeem_vouchers: 'Validasi dan tukarkan voucher',
    to_get_started: 'Masukkan atau pindai kode QR voucher Anda untuk memulai',
    write_your_code: 'Tulis kode Anda...',
    validate: 'Validasi',
    back_to_store: 'Kembali ke toko',
    scan_qr: 'Pindai QR',
    scan_on_the_voucher: 'Untuk memulai, pindai QR pada voucher',
    view_history: 'Lihat riwayat',
    voucher_history: 'Riwayat voucher',
    voucher_history_description:
        'Riwayat ini memungkinkan Anda melacak penukaran dengan akurat, memudahkan pemantauan dan pengelolaan hadiah yang telah Anda kumpulkan.',
    see_more: 'Lihat lebih banyak',
    see_less: 'Lihat lebih sedikit',

    //Faltantes
    upload_image: 'Unggah Gambar',
    uploaded_image: 'Gambar Diunggah',
    photo: 'Foto',
    edit: 'Edit',
    delete: 'Hapus',
    enter_a_comment: 'Masukkan Komentar',
    enter_a_value: 'Masukkan Nilai',
    want_to_check_out: 'Apakah Anda yakin ingin melakukan check-out?',
    not_check_in_again: 'Setelah dikonfirmasi, Anda tidak akan dapat melakukan check-in lagi hingga kunjungan berikutnya.',

    //Alert
    alert: 'Peringatan',
    enter_characters: 'Anda harus memasukkan 10 karakter setelah awalan',
    numerical_field: 'Kolom yang diedit harus berupa angka, tanpa spasi atau huruf.',
    enter_date_of_birth: 'Masukkan tanggal lahir yang valid dalam format YYYY-MM-DD.',
    session_expired: 'Sesi kedaluwarsa',
    your_session_has_expired: 'Sesi Anda telah kedaluwarsa. Silakan coba lagi.',
    error: 'Kesalahan',
    error_occurred: 'Terjadi kesalahan saat mencoba mengubah kata sandi.',
    email_verification_code_incorrect: 'Kode verifikasi email salah.',
    phone_verification_code_incorrect: 'Kode verifikasi telepon salah.',
    no_checkin_found: 'Check-in tidak ditemukan.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
